module.exports = __webpack_public_path__ + "media/images/icons/flags/SK-3584742e008d8bf32b21ca3ed8057fec.svg";